import { useCallback, useContext } from 'react'
import { useNavigate, useRouter } from '@tanstack/react-router'
import { AuthContext } from '@/features/Auth/application/AuthContext'
import { authService } from '@/features/Auth/infrastructure/services/authService'

export const useLogout = (needNavigate = true) => {
  const navigate = useNavigate()
  const { setAuthState } = useContext(AuthContext)

  return useCallback(async () => {
    try {
      setAuthState({ authStatus: 'signedOut' })
      localStorage.clear()
      sessionStorage.clear()
      await authService.logout()

      if (needNavigate) {
        await navigate({ to: '/auth/login' })
      }
    } catch (error) {
      localStorage.clear()
      sessionStorage.clear()
      setAuthState({ authStatus: 'signedOut' })

      if (needNavigate) {
        await navigate({ to: '/auth/login' })
      }
    }
  }, [navigate, setAuthState, needNavigate])
}
